import { FC, useMemo } from 'react'
import { Flex, Popover, Space, Typography } from 'antd'
import CalculationPosition from '../../../../../../types/api/calculation-position'
import { getUniqueMaterials } from '../../../../../../helpers/get-unique-material-types'

const { Text } = Typography

interface CorrectMaterialCostNamesProps {
    data: CalculationPosition
}

const CorrectMaterialCostNames: FC<CorrectMaterialCostNamesProps> = ({ data }) => {
    const materialTypes = useMemo(() => getUniqueMaterials(data), [data])
    const materialTypesDocIds = useMemo(() => materialTypes.map(x => x.documentId), [materialTypes])
    const actualCorrects = useMemo(() => {
        return (
            data.correctMaterialCost?.filter(x =>
                materialTypesDocIds.includes(x.material_type?.documentId || '')
            ) || []
        )
    }, [materialTypesDocIds, data.correctMaterialCost])

    const summary = useMemo(
        () => actualCorrects.reduce((acc, x) => acc + (x.cost || 0), 0),
        [actualCorrects]
    )

    const groups = useMemo(() => {
        return actualCorrects
            .map(x => {
                const docId = x.material_type?.documentId || ''

                if (docId) {
                    return { title: x.material_type?.name || '', cost: x.cost }
                }

                return undefined
            })
            .filter(Boolean)
    }, [actualCorrects])

    return (
        <Popover
            trigger='hover'
            placement='leftBottom'
            content={
                <Space direction='vertical' style={{ minWidth: 200 }}>
                    {groups.map(group => (
                        <Flex gap={8} key={group?.title}>
                            <Text>{group?.title || ''}</Text>
                            <Text strong>{group?.cost || 0}</Text>
                        </Flex>
                    ))}
                </Space>
            }
        >
            {summary ? Math.round(summary * 1000) / 1000 : null}
        </Popover>
    )
}

export default CorrectMaterialCostNames
